/* ZERO LIMIT – SIGNATURE 2.0 */
(() => {
  "use strict";
  const ZL = window.ZL || { routes: {}, strings: {}, moneyFormat: "{{amount_with_comma_separator}} €" };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const root = (ZL.routes.root || "/").replace(/\/?$/, "/");

  /* ---------- Money ---------- */
  const formatMoney = (cents) => {
    const value = Number(cents) || 0;
    const fmt = ZL.moneyFormat || "{{amount_with_comma_separator}} €";
    const delim = (n, d, t, s) => {
      const fixed = (n / 100).toFixed(d);
      const [i, f] = fixed.split(".");
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? s + f : "");
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case "amount": return delim(value, 2, ",", ".");
        case "amount_no_decimals": return delim(value, 0, ",", ".");
        case "amount_no_decimals_with_comma_separator": return delim(value, 0, ".", ",");
        case "amount_with_space_separator": return delim(value, 2, " ", ",");
        case "amount_with_apostrophe_separator": return delim(value, 2, "'", ".");
        default: return delim(value, 2, ".", ",");
      }
    });
  };

  /* ---------- Toast ---------- */
  let toastTimer;
  const toast = (msg) => {
    const el = $("[data-toast]");
    if (!el) return;
    el.textContent = msg;
    el.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove("is-visible"), 2600);
  };

  /* ---------- Drawers / overlay ---------- */
  const overlay = $("[data-overlay]");
  let openDrawer = null;
  let lastFocus = null;
  const lock = (on) => document.body.classList.toggle("z-lock", on);

  const closeAll = () => {
    if (openDrawer) {
      openDrawer.classList.remove("is-open");
      openDrawer.setAttribute("aria-hidden", "true");
      $$(`[aria-controls="${openDrawer.id}"]`).forEach((b) => b.setAttribute("aria-expanded", "false"));
      openDrawer = null;
    }
    const search = $("[data-search]");
    if (search && search.classList.contains("is-open")) {
      search.classList.remove("is-open");
      $$("[data-search-open]").forEach((b) => b.setAttribute("aria-expanded", "false"));
    }
    overlay && overlay.classList.remove("is-open");
    lock(false);
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  };

  const open = (drawer) => {
    if (!drawer) return;
    if (openDrawer && openDrawer !== drawer) closeAll();
    lastFocus = document.activeElement;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute("aria-expanded", "true"));
    overlay && overlay.classList.add("is-open");
    openDrawer = drawer;
    lock(true);
    setTimeout(() => {
      const f = drawer.querySelector("[data-drawer-close], a, button, input");
      f && f.focus({ preventScroll: true });
    }, 60);
  };

  document.addEventListener("click", (e) => {
    const opener = e.target.closest("[data-drawer-open]");
    if (opener) {
      e.preventDefault();
      open(document.getElementById(opener.dataset.drawerOpen));
      return;
    }
    if (e.target.closest("[data-cart-open]")) {
      const cart = $("[data-cart-drawer]");
      if (cart && !document.body.classList.contains("z-t-cart")) {
        e.preventDefault();
        open(cart);
      }
      return;
    }
    if (e.target.closest("[data-drawer-close]") || e.target === overlay) {
      closeAll();
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    const modal = $(".z-modal.is-open");
    if (modal) return closeModal(modal);
    closeAll();
  });

  /* ---------- Modals ---------- */
  const openModal = (m) => {
    if (!m) return;
    lastFocus = document.activeElement;
    m.classList.add("is-open");
    lock(true);
    setTimeout(() => { const c = m.querySelector("[data-modal-close].z-icon-btn, button"); c && c.focus(); }, 50);
  };
  const closeModal = (m) => {
    m.classList.remove("is-open");
    if (!openDrawer) lock(false);
    lastFocus && lastFocus.focus({ preventScroll: true });
  };
  document.addEventListener("click", (e) => {
    const o = e.target.closest("[data-modal-open]");
    if (o) { e.preventDefault(); openModal(document.getElementById(o.dataset.modalOpen)); return; }
    const c = e.target.closest("[data-modal-close]");
    if (c) { const m = c.closest("[data-modal]"); m && closeModal(m); }
  });

  /* ---------- Announcement ---------- */
  const initAnnouncement = () => {
    const bar = $("[data-announce]");
    if (!bar) return;
    const items = $$(".z-announce__item", bar);
    if (items.length < 2 || reduced) return;
    let i = 0;
    const ms = Number(bar.dataset.interval) || 4000;
    setInterval(() => {
      if (document.hidden) return;
      items[i].classList.remove("is-active");
      i = (i + 1) % items.length;
      items[i].classList.add("is-active");
    }, ms);
  };

  /* ---------- Header ---------- */
  const initHeader = () => {
    const header = $("[data-header]");
    if (!header) return;
    const onScroll = () => header.classList.toggle("is-scrolled", window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  };

  /* ---------- Search ---------- */
  const initSearch = () => {
    const panel = $("[data-search]");
    if (!panel) return;
    const input = $("[data-search-input]", panel);
    const results = $("[data-search-results]", panel);
    const initial = results.innerHTML;
    let ctrl;

    const show = () => {
      if (openDrawer) closeAll();
      lastFocus = document.activeElement;
      panel.classList.add("is-open");
      overlay && overlay.classList.add("is-open");
      $$("[data-search-open]").forEach((b) => b.setAttribute("aria-expanded", "true"));
      lock(true);
      setTimeout(() => input.focus(), 80);
    };
    $$("[data-search-open]").forEach((b) => b.addEventListener("click", show));
    $("[data-search-close]", panel)?.addEventListener("click", closeAll);
    overlay?.addEventListener("click", closeAll);

    const render = (products, q) => {
      if (!products.length) {
        results.innerHTML = `<p class="z-lead">${ZL.strings.noResults || "Keine Treffer."}</p>`;
        return;
      }
      const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
      results.innerHTML =
        `<div class="z-search__grid">` +
        products.map((p) => {
          const img = p.featured_image && p.featured_image.url ? `${p.featured_image.url}${p.featured_image.url.includes("?") ? "&" : "?"}width=400` : "";
          const price = formatMoney(Math.round(parseFloat(p.price) * 100));
          const title = esc(String(p.title).replace(/^ZERO LIMIT /, ""));
          return `<article class="z-card"><div class="z-media z-card__media">${img ? `<img class="z-card__main" src="${img}" alt="" loading="lazy">` : ""}</div>
            <div class="z-card__info"><h3 class="z-card__title"><a href="${p.url}">${title}</a></h3><span class="z-price"><span>${price}</span></span></div></article>`;
        }).join("") +
        `</div><p style="margin-top:24px"><a class="z-link" href="${ZL.routes.search}?q=${encodeURIComponent(q)}&type=product&options%5Bprefix%5D=last">${ZL.strings.viewAll || "Alle Ergebnisse"} →</a></p>`;
    };

    let t;
    input.addEventListener("input", () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = initial; return; }
      t = setTimeout(async () => {
        ctrl && ctrl.abort();
        ctrl = new AbortController();
        try {
          const url = `${ZL.routes.predictive || "/search/suggest"}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;
          const r = await fetch(url, { signal: ctrl.signal });
          const data = await r.json();
          render(((data.resources || {}).results || {}).products || [], q);
        } catch (err) { /* aborted */ }
      }, 220);
    });
  };

  /* ---------- Cart ---------- */
  const updateCount = (count) => {
    $$("[data-cart-count]").forEach((el) => {
      el.textContent = count;
      el.dataset.count = count;
      el.classList.remove("is-bump");
      void el.offsetWidth;
      el.classList.add("is-bump");
    });
  };

  const renderDrawer = (html) => {
    const drawer = $("[data-cart-drawer]");
    if (!drawer || !html) return;
    const doc = new DOMParser().parseFromString(html, "text/html");
    const fresh = doc.querySelector("[data-cart-drawer]");
    if (fresh) drawer.innerHTML = fresh.innerHTML;
  };

  const cartRequest = async (url, body) => {
    const r = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ ...body, sections: "cart-drawer", sections_url: window.location.pathname })
    });
    const data = await r.json();
    if (!r.ok || data.status) throw new Error(data.description || data.message || ZL.strings.error);
    return data;
  };

  const changeLine = async (line, quantity, el) => {
    el && el.classList.add("is-busy");
    try {
      const data = await cartRequest(`${ZL.routes.cartChange || "/cart/change"}.js`, { line, quantity });
      renderDrawer(data.sections && data.sections["cart-drawer"]);
      updateCount(data.item_count);
    } catch (err) {
      toast(err.message || ZL.strings.error);
      el && el.classList.remove("is-busy");
    }
  };

  const initCartDrawer = () => {
    const drawer = $("[data-cart-drawer]");
    if (!drawer) return;
    drawer.addEventListener("click", (e) => {
      const line = e.target.closest("[data-line]");
      if (!line) return;
      const idx = Number(line.dataset.line);
      const input = $("[data-line-qty]", line);
      if (e.target.closest("[data-line-remove]")) return changeLine(idx, 0, line);
      const step = e.target.closest("[data-qty-change]");
      if (step) {
        const q = Math.max(0, Number(input.value) + Number(step.dataset.qtyChange));
        input.value = q;
        changeLine(idx, q, line);
      }
    });
    drawer.addEventListener("change", (e) => {
      if (!e.target.matches("[data-line-qty]")) return;
      const line = e.target.closest("[data-line]");
      changeLine(Number(line.dataset.line), Math.max(0, Number(e.target.value)), line);
    });
  };

  const addToCart = async (formData) => {
    formData.append("sections", "cart-drawer");
    formData.append("sections_url", window.location.pathname);
    const r = await fetch(`${ZL.routes.cartAdd || "/cart/add"}.js`, {
      method: "POST",
      headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: formData
    });
    const data = await r.json();
    if (!r.ok || data.status) throw new Error(data.description || data.message || ZL.strings.error);
    renderDrawer(data.sections && data.sections["cart-drawer"]);
    try {
      const cart = await fetch(`${root}cart.js`).then((x) => x.json());
      updateCount(cart.item_count);
    } catch (e) { /* ignore */ }
    open($("[data-cart-drawer]"));
    return data;
  };

  /* ---------- Hero colour lab ---------- */
  const initHero = () => {
    const hero = $("[data-hero]");
    if (!hero) return;
    const sws = $$("[data-hero-sw]", hero);
    if (!sws.length) return;
    const imgs = $$("img.z-hero__img", hero);
    const nameEl = $("[data-hero-name]", hero);
    const cta = $("[data-hero-cta]", hero);
    const link = $("[data-hero-link]", hero);
    const progress = $("[data-hero-progress]", hero);
    const ms = Number(hero.dataset.interval) || 3000;
    if (progress) progress.style.setProperty("--z-cycle", ms + "ms");
    let idx = Math.max(0, sws.findIndex((b) => b.getAttribute("aria-checked") === "true"));
    let front = imgs[0];
    let timer = null;
    let userTook = false;
    let visible = true;
    let token = 0;

    const apply = (i) => {
      const b = sws[i];
      sws.forEach((s) => s.setAttribute("aria-checked", String(s === b)));
      if (nameEl) nameEl.textContent = b.dataset.name;
      hero.style.setProperty("--tint", b.dataset.tint);
      hero.style.setProperty("--tint-deep", b.dataset.deep);
      if (cta && b.dataset.url) cta.href = b.dataset.url;
      if (link && b.dataset.url) link.href = b.dataset.url;
      const back = imgs.find((im) => im !== front) || imgs[0];
      const my = ++token;
      back.onload = () => {
        if (my !== token) return;
        back.classList.remove("is-hidden");
        back.removeAttribute("aria-hidden");
        back.alt = front.alt;
        front.classList.add("is-hidden");
        front.setAttribute("aria-hidden", "true");
        front = back;
      };
      back.sizes = front.sizes || "(min-width: 990px) 52vw, 100vw";
      back.srcset = b.dataset.srcset;
      back.src = b.dataset.src;
      if (back.complete && back.naturalWidth) back.onload();
    };

    const preload = (i) => {
      const b = sws[i];
      if (!b || b.dataset.pre) return;
      const im = new Image();
      im.sizes = front.sizes || "(min-width: 990px) 52vw, 100vw";
      im.srcset = b.dataset.srcset;
      im.src = b.dataset.src;
      b.dataset.pre = "1";
    };

    const restartProgress = () => {
      if (!progress) return;
      progress.classList.remove("is-running");
      void progress.offsetWidth;
      progress.classList.add("is-running");
    };

    const stop = () => {
      clearInterval(timer);
      timer = null;
      progress && progress.classList.remove("is-running");
    };
    const start = () => {
      if (userTook || reduced || hero.dataset.autoplay !== "true" || timer || !visible) return;
      restartProgress();
      preload((idx + 1) % sws.length);
      timer = setInterval(() => {
        if (document.hidden) return;
        idx = (idx + 1) % sws.length;
        apply(idx);
        preload((idx + 1) % sws.length);
        restartProgress();
      }, ms);
    };

    sws.forEach((b, i) => {
      b.addEventListener("click", () => {
        userTook = true;
        stop();
        idx = i;
        apply(i);
      });
      b.addEventListener("pointerenter", () => preload(i), { passive: true });
    });

    hero.addEventListener("keydown", (e) => {
      if (!e.target.matches("[data-hero-sw]")) return;
      if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
      e.preventDefault();
      userTook = true;
      stop();
      idx = (idx + (e.key === "ArrowRight" ? 1 : -1) + sws.length) % sws.length;
      apply(idx);
      sws[idx].focus();
    });

    if ("IntersectionObserver" in window) {
      new IntersectionObserver((entries) => {
        visible = entries[0].isIntersecting;
        visible ? start() : stop();
      }, { threshold: 0.25 }).observe(hero);
    } else start();
  };

  /* ---------- Set cards ---------- */
  const initSets = () => {
    $$("[data-set]").forEach((card) => {
      const img = $(".z-set__img", card);
      const link = $("[data-set-link]", card);
      const sws = $$("[data-set-sw]", card);
      const pick = (b) => {
        sws.forEach((s) => s.setAttribute("aria-pressed", String(s === b)));
        card.style.setProperty("--tint", b.dataset.tint);
        if (img) {
          img.style.opacity = "0";
          const n = new Image();
          n.sizes = img.sizes;
          n.srcset = b.dataset.srcset;
          n.src = b.dataset.src;
          const swap = () => { img.srcset = b.dataset.srcset; img.src = b.dataset.src; img.style.opacity = "1"; };
          n.complete ? swap() : (n.onload = swap, n.onerror = swap);
        }
        if (link && b.dataset.url) link.href = b.dataset.url;
      };
      sws.forEach((b) => {
        b.addEventListener("click", (e) => { e.preventDefault(); pick(b); });
        b.addEventListener("pointerenter", (e) => { if (e.pointerType === "mouse") pick(b); });
      });
    });
  };

  /* ---------- Filter tabs (home grid) ---------- */
  const initGridFilter = () => {
    $$("[data-filter-grid]").forEach((wrap) => {
      const chips = $$("[data-filter]", wrap);
      const items = $$("[data-type]", wrap);
      chips.forEach((c) => c.addEventListener("click", () => {
        chips.forEach((x) => x.setAttribute("aria-pressed", String(x === c)));
        const f = c.dataset.filter;
        items.forEach((it) => { it.hidden = !(f === "all" || it.dataset.type === f); });
      }));
    });
  };

  /* ---------- Product ---------- */
  const initProduct = () => {
    const section = $("[data-product-section]");
    if (!section) return;
    const jsonEl = $("[data-product-json]");
    let data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    const form = $("[data-product-form]", section);
    const idInput = form && $("[data-variant-id]", form);
    const atc = form && $("[data-atc]", form);
    const atcLabel = atc && $("[data-atc-label]", atc);
    const errorBox = form && $("[data-form-error]", form);
    const priceWrap = $("[data-product-price]", section);
    const rail = $("[data-gallery-rail]", section);
    const thumbs = $$("[data-thumb]", section);
    const count = $("[data-gallery-count]", section);
    const sticky = $("[data-sticky-buy]");
    const stickyPrice = sticky && $("[data-sticky-price]", sticky);
    const fieldsets = $$("[data-option]", section);
    const S = ZL.strings;

    /* gallery */
    const slides = () => $$("[data-slide]", rail).filter((s) => !s.hidden);
    const currentIndex = () => {
      const list = slides();
      if (!list.length) return 0;
      const w = rail.clientWidth || 1;
      return Math.min(list.length - 1, Math.round(rail.scrollLeft / w));
    };
    const syncGallery = () => {
      const list = slides();
      const i = currentIndex();
      if (count) count.textContent = `${i + 1} / ${list.length}`;
      const id = list[i] && list[i].dataset.mediaId;
      thumbs.forEach((t) => t.setAttribute("aria-current", String(t.dataset.thumb === id)));
    };
    const goTo = (mediaId, smooth = true) => {
      const list = slides();
      const i = list.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (i < 0) return;
      rail.scrollTo({ left: i * rail.clientWidth, behavior: smooth && !reduced ? "smooth" : "auto" });
    };
    if (rail) {
      let raf;
      rail.addEventListener("scroll", () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(syncGallery); }, { passive: true });
      $("[data-gallery-prev]", section)?.addEventListener("click", () => rail.scrollBy({ left: -rail.clientWidth, behavior: "smooth" }));
      $("[data-gallery-next]", section)?.addEventListener("click", () => rail.scrollBy({ left: rail.clientWidth, behavior: "smooth" }));
      thumbs.forEach((t) => t.addEventListener("click", () => goTo(t.dataset.thumb)));
      rail.addEventListener("keydown", (e) => {
        if (e.key === "ArrowRight") rail.scrollBy({ left: rail.clientWidth, behavior: "smooth" });
        if (e.key === "ArrowLeft") rail.scrollBy({ left: -rail.clientWidth, behavior: "smooth" });
      });
      syncGallery();
    }
    const zoomModal = $("[data-zoom-modal]");
    section.addEventListener("click", (e) => {
      const z = e.target.closest("[data-zoom]");
      if (!z || !zoomModal) return;
      const img = $("[data-zoom-img]", zoomModal);
      img.src = z.dataset.zoom;
      openModal(zoomModal);
    });

    const filterColor = (color) => {
      if (!data.colorMedia || !color || !rail) return;
      $$("[data-slide][data-color]", rail).forEach((s) => { s.hidden = s.dataset.color !== color; });
      thumbs.filter((t) => t.dataset.color).forEach((t) => { t.hidden = t.dataset.color !== color; });
      const slide = $$("[data-slide][data-color]", rail).find((s) => s.dataset.color === color);
      if (slide) rail.prepend(slide);
      const thumb = thumbs.find((t) => t.dataset.color === color);
      if (thumb && thumb.parentElement) thumb.parentElement.prepend(thumb);
      rail.scrollTo({ left: 0, behavior: "auto" });
      syncGallery();
    };

    /* variants */
    const selected = () => fieldsets.map((fs) => {
      const c = $("input:checked", fs);
      return c ? c.value : null;
    });

    const findVariant = (opts) => data.variants.find((v) => v.options.every((o, i) => opts[i] === o));

    const setPrice = (v) => {
      if (!priceWrap || !v) return;
      const sale = v.compare > v.price;
      const pct = sale ? Math.round(((v.compare - v.price) * 100) / v.compare) : 0;
      priceWrap.innerHTML = `<span class="z-price${sale ? " z-price--sale" : ""}"><span>${formatMoney(v.price)}</span>${sale ? ` <s>${formatMoney(v.compare)}</s>` : ""}</span>${sale ? `<span class="z-badge z-badge--sale">−${pct}%</span>` : ""}`;
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
    };

    const sizeIdx = data.sizePos ? data.sizePos - 1 : -1;
    const colorIdx = data.colorPos ? data.colorPos - 1 : -1;

    const update = (fromUser) => {
      const opts = selected();
      fieldsets.forEach((fs, i) => {
        const lbl = $("[data-option-label]", fs);
        if (lbl) lbl.textContent = opts[i] || "—";
      });
      // availability of sizes for the chosen colour
      if (sizeIdx >= 0) {
        const fs = fieldsets[sizeIdx];
        $$("input", fs).forEach((inp) => {
          const test = opts.slice();
          test[sizeIdx] = inp.value;
          const v = findVariant(test);
          inp.classList.toggle("is-unavailable", !v || !v.available);
        });
      }
      const missing = opts.some((o) => o === null);
      const v = missing ? null : findVariant(opts);
      if (errorBox && fromUser) errorBox.hidden = true;
      if (sizeIdx >= 0 && opts[sizeIdx]) fieldsets[sizeIdx].classList.remove("is-error");

      if (colorIdx >= 0 && fromUser === "color") filterColor(opts[colorIdx]);

      // show a matching variant's price even before size is picked
      const anyForColor = v || data.variants.find((x) => colorIdx < 0 || x.options[colorIdx] === opts[colorIdx]);
      setPrice(anyForColor);

      const stickyBtn = sticky && $("[data-sticky-atc]", sticky);
      if (stickyBtn) stickyBtn.textContent = missing ? (S.chooseSize || "Größe wählen") : (v && v.available ? S.addToCart : (S.soldOut || ""));
      if (!atc) return;
      if (missing) {
        atcLabel.textContent = S.chooseSize || "Größe wählen";
        atc.disabled = false;
        atc.dataset.needsSize = "1";
      } else if (!v || !v.available) {
        atcLabel.textContent = v ? S.soldOut : S.unavailable;
        atc.disabled = true;
        delete atc.dataset.needsSize;
      } else {
        atcLabel.textContent = S.addToCart;
        atc.disabled = false;
        delete atc.dataset.needsSize;
      }
      if (v) {
        idInput.value = v.id;
        if (fromUser) {
          const url = new URL(window.location.href);
          url.searchParams.set("variant", v.id);
          history.replaceState({}, "", url);
        }
        if (!data.colorMedia && v.media && fromUser) goTo(v.media);
      } else if (!data.colorMedia && fromUser === "color" && anyForColor && anyForColor.media) {
        goTo(anyForColor.media);
      }
    };

    fieldsets.forEach((fs, i) => fs.addEventListener("change", () => update(i === colorIdx ? "color" : "other")));
    update(false);
    if (!data.colorMedia && idInput && rail) {
      const cur = data.variants.find((x) => String(x.id) === String(idInput.value));
      if (cur && cur.media) requestAnimationFrame(() => goTo(cur.media, false));
    }
    if (data.colorMedia && colorIdx >= 0) {
      const c = selected()[colorIdx];
      if (c) filterColor(c);
    }

    const needSize = () => {
      const fs = fieldsets[sizeIdx];
      if (!fs) return;
      fs.classList.remove("is-error");
      void fs.offsetWidth;
      fs.classList.add("is-error");
      if (errorBox) { errorBox.textContent = S.pickSize || "Bitte wähle zuerst deine Größe."; errorBox.hidden = false; }
      fs.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "center" });
    };

    /* qty */
    section.addEventListener("click", (e) => {
      const b = e.target.closest("[data-qty-step]");
      if (!b) return;
      const input = b.parentElement.querySelector("input");
      input.value = Math.max(1, Number(input.value || 1) + Number(b.dataset.qtyStep));
    });

    /* submit */
    form && form.addEventListener("submit", async (e) => {
      e.preventDefault();
      if (atc.dataset.needsSize) return needSize();
      atc.classList.add("is-loading");
      atc.disabled = true;
      errorBox && (errorBox.hidden = true);
      try {
        await addToCart(new FormData(form));
      } catch (err) {
        if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; }
      } finally {
        atc.classList.remove("is-loading");
        atc.disabled = false;
      }
    });

    /* sticky buy */
    if (sticky && atc && "IntersectionObserver" in window) {
      new IntersectionObserver(([en]) => {
        const past = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle("is-visible", past);
        sticky.setAttribute("aria-hidden", String(!past));
        $("[data-sticky-atc]", sticky).tabIndex = past ? 0 : -1;
      }).observe(atc);
      $("[data-sticky-atc]", sticky).addEventListener("click", () => {
        if (atc.dataset.needsSize) return needSize();
        form.requestSubmit ? form.requestSubmit() : atc.click();
      });
    }
  };

  /* ---------- Size tables: cm only + German labels ---------- */
  const initSizeTables = () => {
    const de = (document.documentElement.lang || "de").startsWith("de");
    const labels = { "length": "Länge", "shoulder": "Schulter", "chest": "Brust", "sleeve length": "Ärmellänge", "sleeve": "Ärmel", "waist": "Bund", "hip": "Hüfte", "hips": "Hüfte", "inseam": "Innenbein", "thigh": "Oberschenkel", "leg opening": "Beinöffnung", "front rise": "Leibhöhe vorne", "back rise": "Leibhöhe hinten", "pants length": "Hosenlänge", "body length": "Länge", "width": "Weite" };
    $$(".z-table-wrap table").forEach((table) => {
      if (table.dataset.zDone) return;
      table.dataset.zDone = "1";
      table.removeAttribute("style");
      const rows = $$("tr", table);
      const unitRow = rows.find((r) => /inch/i.test(r.textContent) && /cm/i.test(r.textContent));
      if (unitRow) {
        const unitIdx = $$("td,th", unitRow).map((c, i) => (/^\s*inch\s*$/i.test(c.textContent) ? i : -1)).filter((i) => i >= 0);
        const start = rows.indexOf(unitRow);
        rows.slice(start).forEach((r) => {
          const cells = $$("td,th", r);
          unitIdx.slice().reverse().forEach((i) => cells[i] && cells[i].remove());
        });
        rows.slice(0, start).forEach((r) => $$("[colspan]", r).forEach((c) => { if (c.getAttribute("colspan") === "2") c.removeAttribute("colspan"); }));
        unitRow.remove();
        const head = rows[0] && rows[0].querySelector("td,th");
        if (head && !head.textContent.trim()) head.textContent = "cm";
      }
      if (de) rows.forEach((r) => {
        const c = r.querySelector("td,th");
        if (!c) return;
        const k = c.textContent.trim().toLowerCase();
        if (labels[k]) c.textContent = labels[k];
      });
    });
  };

  /* ---------- Card colour dots (model photo swap) ---------- */
  const initCardSwatches = (scope = document) => {
    $$("[data-card]", scope).forEach((card) => {
      if (card.dataset.swReady) return;
      card.dataset.swReady = "1";
      const img = $(".z-card__main", card);
      const link = $("[data-card-link]", card);
      const sws = $$("[data-card-sw]", card);
      if (!img || !sws.length) return;
      const pick = (b) => {
        if (b.getAttribute("aria-pressed") === "true") return;
        sws.forEach((x) => x.setAttribute("aria-pressed", String(x === b)));
        img.classList.add("is-swapping");
        const n = new Image();
        n.sizes = img.sizes;
        n.srcset = b.dataset.srcset;
        n.src = b.dataset.src;
        const swap = () => { img.srcset = b.dataset.srcset; img.src = b.dataset.src; requestAnimationFrame(() => img.classList.remove("is-swapping")); };
        n.complete ? swap() : (n.onload = swap, n.onerror = swap);
        if (link && b.dataset.url) link.href = b.dataset.url;
      };
      sws.forEach((b) => {
        b.addEventListener("pointerenter", (e) => { if (e.pointerType === "mouse") pick(b); });
        b.addEventListener("click", (e) => { e.preventDefault(); pick(b); });
      });
    });
  };

  /* ---------- Hero reel (lifestyle slideshow) ---------- */
  const initReel = () => {
    $$("[data-reel]").forEach((reel) => {
      const slides = $$("[data-reel-slide]", reel);
      const chapters = $$("[data-reel-go]", reel);
      if (slides.length < 2) return;
      const ms = Number(reel.dataset.interval) || 6000;
      reel.style.setProperty("--dur", `${ms}ms`);
      chapters.forEach((c) => c.style.setProperty("--dur", `${ms}ms`));
      let i = 0;
      let timer = null;
      let visible = true;
      const go = (n) => {
        slides[i].classList.remove("is-active");
        chapters[i] && (chapters[i].classList.remove("is-active"), chapters[i].setAttribute("aria-selected", "false"));
        chapters.forEach((c, k) => c.classList.toggle("is-done", k < n));
        i = (n + slides.length) % slides.length;
        if (i === 0) chapters.forEach((c) => c.classList.remove("is-done"));
        const img = $("img", slides[i]);
        if (img && img.loading === "lazy") img.loading = "eager";
        slides[i].classList.add("is-active");
        if (chapters[i]) {
          chapters[i].classList.remove("is-active");
          void chapters[i].offsetWidth;
          chapters[i].classList.add("is-active");
          chapters[i].setAttribute("aria-selected", "true");
        }
        const next = $("img", slides[(i + 1) % slides.length]);
        if (next && next.loading === "lazy") next.loading = "eager";
      };
      const start = () => { if (reduced || timer || !visible) return; timer = setInterval(() => { if (!document.hidden) go(i + 1); }, ms); };
      const stop = () => { clearInterval(timer); timer = null; };
      chapters.forEach((c) => c.addEventListener("click", () => { stop(); go(Number(c.dataset.reelGo)); start(); }));
      if ("IntersectionObserver" in window) {
        new IntersectionObserver(([en]) => { visible = en.isIntersecting; visible ? start() : stop(); }, { threshold: 0.2 }).observe(reel);
      } else start();
      if (reduced) chapters.forEach((c) => c.classList.add("is-done"));
    });
  };

  /* ---------- Recommendations ---------- */
  const initRecs = () => {
    $$("[data-recs]").forEach(async (el) => {
      if (el.querySelector(".z-grid")) return;
      try {
        const html = await fetch(el.dataset.url).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, "text/html");
        const fresh = doc.querySelector("[data-recs]");
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initSplit(el); observeReveal(el); initCardSwatches(el); }
        else el.hidden = true;
      } catch (e) { el.hidden = true; }
    });
  };

  /* ---------- Collection ---------- */
  const initCollection = () => {
    $$("[data-sort]").forEach((s) => s.addEventListener("change", () => {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", s.value);
      url.searchParams.delete("page");
      window.location.href = url.toString();
    }));
  };

  /* ---------- Motion: split headlines ---------- */
  const initSplit = (scope = document) => {
    $$("[data-split]", scope).forEach((el) => {
      if (el.dataset.splitDone) return;
      el.dataset.splitDone = "1";
      let i = 0;
      const walk = (node) => {
        [...node.childNodes].forEach((child) => {
          if (child.nodeType === 3) {
            const parts = child.textContent.split(/(\s+)/);
            const frag = document.createDocumentFragment();
            parts.forEach((part) => {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(" ")); return; }
              const w = document.createElement("span");
              w.className = "z-w";
              const inner = document.createElement("span");
              inner.textContent = part;
              inner.style.setProperty("--i", i++);
              w.appendChild(inner);
              frag.appendChild(w);
            });
            child.replaceWith(frag);
          } else if (child.nodeType === 1 && !child.classList.contains("z-w")) {
            walk(child);
          }
        });
      };
      walk(el);
    });
  };

  /* ---------- Motion: scroll engine (parallax, film, velocity) ---------- */
  const initMotion = () => {
    if (reduced) return;
    const parallax = $$("[data-parallax]");
    const marquees = () => $$(".z-marquee__track, [data-velocity]");
    const films = $$("[data-film]").map((film) => ({
      film,
      pin: $("[data-film-pin]", film),
      track: $("[data-film-track]", film),
      frames: $$("[data-frame]", film),
      bg: $("[data-film-bg]", film),
      current: $("[data-film-current]", film),
      progress: $("[data-film-progress]", film),
      dist: 0,
      pinned: false
    }));
    const hero = $("[data-hero]");
    const heroMono = hero && $(".z-hero__mono", hero);
    const desktop = window.matchMedia("(min-width: 990px)");
    const headerH = () => ($("[data-header]") || { offsetHeight: 0 }).offsetHeight;

    const layoutFilms = () => {
      films.forEach((f) => {
        f.pinned = desktop.matches;
        f.film.classList.toggle("is-pinned", f.pinned);
        if (!f.pinned) { f.film.style.removeProperty("--film-h"); f.track.style.removeProperty("--tx"); return; }
        f.track.style.setProperty("--tx", "0px");
        f.dist = Math.max(0, f.track.scrollWidth - window.innerWidth);
        f.film.style.setProperty("--film-h", `${f.pin.offsetHeight + f.dist}px`);
      });
    };

    const setFilm = (f, p) => {
      const n = f.frames.length || 1;
      if (f.progress) f.progress.parentElement.style.setProperty("--p", `${Math.max(8, p * 100)}%`);
      if (f.current) {
        const idx = Math.min(n, Math.round(p * (n - 1)) + 1);
        f.current.textContent = String(idx).padStart(2, "0");
      }
      if (f.bg) f.bg.style.setProperty("--bgx", `${-p * window.innerWidth * 0.45}px`);
      const vw = window.innerWidth;
      f.frames.forEach((fr) => {
        const r = fr.getBoundingClientRect();
        const d = (r.left + r.width / 2 - vw / 2) / vw; // -1..1
        fr.style.setProperty("--fx", `${(-d * 28).toFixed(1)}px`);
        fr.style.setProperty("--fy", `${(Math.abs(d) * 18).toFixed(1)}px`);
      });
    };

    const update = () => {
      const vh = window.innerHeight;
      // parallax
      parallax.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        const k = parseFloat(el.dataset.parallax) || 0.1;
        const center = r.top + r.height / 2 - vh / 2;
        el.style.setProperty("--py", `${(-center * k).toFixed(1)}px`);
      });
      // films
      films.forEach((f) => {
        if (f.pinned) {
          const r = f.film.getBoundingClientRect();
          const total = f.film.offsetHeight - f.pin.offsetHeight;
          const p = total > 0 ? Math.min(1, Math.max(0, (headerH() - r.top) / total)) : 0;
          f.track.style.setProperty("--tx", `${(-p * f.dist).toFixed(1)}px`);
          setFilm(f, p);
        }
      });
      // hero mono drift with scroll
      if (heroMono) heroMono.style.setProperty("--my", `${(window.scrollY * 0.12).toFixed(1)}px`);
    };

    films.forEach((f) => {
      f.track.addEventListener("scroll", () => {
        if (f.pinned) return;
        const max = f.track.scrollWidth - f.track.clientWidth;
        setFilm(f, max > 0 ? f.track.scrollLeft / max : 0);
      }, { passive: true });
    });

    // scroll velocity → marquee speed
    let lastY = window.scrollY;
    let vel = 0;
    let raf = null;
    const tick = () => {
      const y = window.scrollY;
      vel = vel * 0.85 + (y - lastY) * 0.15;
      lastY = y;
      const rate = 1 + Math.min(Math.abs(vel) / 6, 5);
      marquees().forEach((m) => m.getAnimations().forEach((a) => { if (a.updatePlaybackRate) a.updatePlaybackRate(rate); else a.playbackRate = rate; }));
      update();
      if (Math.abs(vel) > 0.05) raf = requestAnimationFrame(tick);
      else { raf = null; marquees().forEach((m) => m.getAnimations().forEach((a) => (a.playbackRate = 1))); }
    };
    window.addEventListener("scroll", () => { if (!raf) raf = requestAnimationFrame(tick); }, { passive: true });

    // hero mono follows pointer a bit
    if (hero && heroMono && window.matchMedia("(pointer: fine)").matches) {
      hero.addEventListener("pointermove", (e) => {
        const r = hero.getBoundingClientRect();
        heroMono.style.setProperty("--mx", `${(((e.clientX - r.left) / r.width) - 0.5) * 30}px`);
      });
    }

    layoutFilms();
    update();
    films.forEach((f) => { if (!f.pinned) setFilm(f, 0); });
    let rt;
    window.addEventListener("resize", () => { clearTimeout(rt); rt = setTimeout(() => { layoutFilms(); update(); }, 150); });
    window.addEventListener("load", () => { layoutFilms(); update(); });
  };

  /* ---------- Motion: tilt + magnet + counters ---------- */
  const initTilt = () => {
    if (reduced || !window.matchMedia("(pointer: fine)").matches) return;
    $$("[data-tilt-stage]").forEach((stage) => {
      const card = $("[data-tilt]", stage);
      if (!card) return;
      stage.addEventListener("pointermove", (e) => {
        const r = stage.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        card.style.setProperty("--ry", `${(x * 22).toFixed(1)}deg`);
        card.style.setProperty("--rx", `${(-y * 14).toFixed(1)}deg`);
      });
      stage.addEventListener("pointerleave", () => { card.style.removeProperty("--ry"); card.style.removeProperty("--rx"); });
    });
    $$("[data-magnet]").forEach((el) => {
      el.addEventListener("pointermove", (e) => {
        const r = el.getBoundingClientRect();
        el.style.transform = `translate(${((e.clientX - r.left) / r.width - 0.5) * 8}px, ${((e.clientY - r.top) / r.height - 0.5) * 8}px)`;
      });
      el.addEventListener("pointerleave", () => { el.style.transform = ""; });
    });
  };

  const initCounters = () => {
    const els = $$("[data-count]");
    if (!els.length) return;
    const run = (el) => {
      const target = parseInt(el.dataset.count, 10);
      if (!target || reduced) return;
      const t0 = performance.now();
      const dur = 1400;
      const step = (t) => {
        const p = Math.min(1, (t - t0) / dur);
        el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (!("IntersectionObserver" in window)) return;
    const io2 = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { run(en.target); io2.unobserve(en.target); } }), { threshold: 0.6 });
    els.forEach((e) => io2.observe(e));
  };

  /* ---------- Reveal ---------- */
  let io;
  const observeReveal = (scope = document) => {
    const els = $$("[data-reveal], [data-reveal-stagger], [data-split], [data-reveal-img]", scope);
    if (reduced || !("IntersectionObserver" in window)) { els.forEach((e) => e.classList.add("is-in")); return; }
    io = io || new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); }
    }), { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    els.forEach((e) => io.observe(e));
  };

  const ready = (fn) => (document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", fn, { once: true }) : fn());
  ready(() => {
    [initSplit, initAnnouncement, initHeader, initSearch, initCartDrawer, initReel, initHero, initSets, () => initCardSwatches(), initGridFilter, initProduct, initSizeTables, initRecs, initCollection, () => observeReveal(), initMotion, initTilt, initCounters].forEach((fn) => {
      try { fn(); } catch (e) { console.error(e); }
    });
  });

  // Shopify theme editor support
  document.addEventListener("shopify:section:load", () => { initSplit(); observeReveal(); initReel(); initHero(); initSets(); initGridFilter(); initCardSwatches(); });
})();
